import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IconoirNavArrowLeft, IconoirNavArrowRight } from '@ey-xd/motif-icon';
import {
  MotifButtonModule,
  MotifCardModule,
  MotifIconModule,
} from '@ey-xd/ng-motif';
import { AuthenticationService } from 'app/core/service/auth/authentication.service';
import { HomeCard } from 'app/models/home-card';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { ToastService } from 'app/core/service/toast/toast.service';

@Component({
  selector: 'app-ixbrl',
  standalone: true,
  imports: [CommonModule, MotifIconModule, MotifCardModule, MotifButtonModule],
  templateUrl: './ixbrl.component.html',
  styleUrl: './ixbrl.component.scss',
})
export class IxbrlComponent implements OnInit, AfterViewInit {
  //Icons
  IconoirNavArrowLeft = IconoirNavArrowLeft;
  IconoirNavArrowRight = IconoirNavArrowRight;

  @ViewChild('cardsContainer') cardsContainer!: ElementRef;

  showScrollLeft: boolean = false;
  showScrollRight: boolean = false;

  cards: HomeCard[] = [
    // {
    //   agent: 'Step 1',
    //   header: 'Document Acceptance',
    //   content: `
    //     <p>
          
    //     </p>
    //   `,
    //   action: () => this.goToDocumentAcceptance(),
    // },
    {
      agent: '',
      header: 'Document Formatting',
      content: `
        <ol>
          <li> Please use document formatting to format the document, as per the formatting needed to upload to seahorse. </li>
          <li> The document uploaded in document formatting, as pre-requisite it need to complete the document acceptance stage. </li>
          <li> Any document which has failed in the document acceptance stage or more clarification needed form client should not be uploaded to document formatting. </li>
        </ol>
      `,
      action: () => this.goToDocumentFormatting(),
    },
    // {
    //   agent: 'Step 3',
    //   header: 'Document Review',
    //   content: `
    //     <p>
    //
    //     </p>
    //   `,
    //   action: () => this.goToDocumentReview(),
    // },
  ];

  isScrollable: boolean = this.cards.length > 2;

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(
    protected authenticationService: AuthenticationService,
    protected router: Router,
    private toastService: ToastService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe([Breakpoints.Handset, '(max-width: 900px)'])
      .subscribe((result) => {
        this.isZoomed = result.matches;
      });
  }

  ngOnInit(): void {
    this.toastService.clearToastWithTag(true);
  }

  ngAfterViewInit() {
    this.updateScrollButtons();
    this.cardsContainer.nativeElement.addEventListener('scroll', () => {
      this.updateScrollButtons();
    });
  }

  goToDocumentAcceptance() {
    // this.router.navigate(['document-acceptance']);
    this.toastService.showToast('warning', 'Feature will be available soon.', {
      autoHide: false,
      classTheme: '',
    });
  }

  goToDocumentFormatting() {
    this.router.navigate(['document-formatting']);
  }

  // goToDocumentReview() {
  //   this.router.navigate(['document-review']);
  // }

  /**Scroll buttons function */
  scrollCards(direction: 'left' | 'right') {
    const scrollAmount = 300;
    const container = this.cardsContainer.nativeElement as HTMLElement;

    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }

    setTimeout(() => this.updateScrollButtons(), 300);
  }

  updateScrollButtons() {
    const container = this.cardsContainer.nativeElement as HTMLElement;
    const { scrollLeft, scrollWidth, clientWidth } = container;

    this.showScrollLeft = scrollLeft > 0 && this.isScrollable;
    this.showScrollRight =
      scrollLeft + clientWidth < scrollWidth - 1 && this.isScrollable;
  }
}
